export { GeometricStacks } from './GeometricStacks';
export { NoMediaCollected } from './NoMediaCollected';
export { SubmissionsModalDeleteIcon } from './SubmissionsModalDeleteIcon';
export { UpdateThumbnailIcon } from './UpdateThumbnailIcon';
export { PluginCarouselIcon } from './PluginCarouselIcon';
export { PluginListIcon } from './PluginListIcon';
export { PluginGalleryIcon } from './PluginGalleryIcon';
export { PluginPlaylistIcon } from './PluginPlaylistIcon';



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/index.js